<h2 mat-dialog-title>{{'user_group.update_info_user_group' | translate}} {{oldGroupName}}
  <button type="button" class="close" aria-label="Close" (click)="onClickBtnCancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</h2>
<mat-divider></mat-divider>
<!-- them ten nhom nguoi dung -->
<form #f="ngForm" (ngSubmit)="!f.form.valid? 'false' : 'true' && f.form.valid && onUpdate()"
  appFocusFirstElement>

  <div class="row mt-3">
    <div class="col-sm-12">
      <mat-form-field class="mat-full-width">
        <input (focusout)="grUs.name = grUs.name.trim()" cdkFocusInitial #focusInput="matInput" autocomplete="off" id="name" matInput
          [placeholder]="'search_form.user_group_name' | translate" type="text" name="name" [(ngModel)]="grUs.name"
          #name="ngModel" [ngClass]="{ 'is-invalid': f.submitted && name.invalid }" required maxlength="50" />
        <mat-error *ngIf="f.submitted || name.invalid">
          <span class="text-error" *ngIf="name?.errors?.required">
            {{'validation.group_user_name' | translate}}
          </span>
        </mat-error>
        <mat-error *ngIf="name?.errors?.duplicate">
          {{ 'validation.err_user_group_duplicate' | translate }}
        </mat-error>
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12">
      <mat-form-field class="mat-full-width">
        <textarea type="text" matInput [placeholder]="'headertable.description' | translate" rows="3"
          name="description" id="description" [(ngModel)]="grUs.description" maxlength="500"></textarea>
      </mat-form-field>
    </div>
  </div>

  <mat-dialog-actions align="center">
    <button mat-stroked-button color="primary" class="mr-3" (click)="onClickBtnCancel()" type="button">
      <mat-icon class="mr-0">cancel</mat-icon>
      {{'button.cancel' | translate}}
    </button>
    <button mat-raised-button [disabled]="!isFormChanging && !change" type="submit" color="primary">
      <mat-icon class="mr-0">save</mat-icon>
      {{'button.update' | translate}}
    </button>
  </mat-dialog-actions>
</form>
